import graphql from './graphql';

const query = /* GraphQL */ `
  query Terminal_list {
    Terminal_list {
      name
      id
    }
  }
`;

// El backend devuelve `Terminal_list: null` cuando el rol no tiene
// `employee.*` (errors[].extensions.code = FORBIDDEN). Caemos a [] para que
// los dropdowns no crashen.
const terminalList = async () =>
  // eslint-disable-next-line camelcase
  graphql(query).then(response => response?.Terminal_list ?? []);

export default terminalList;
